import { Command, HttpMethod } from "~/extensions/api";
export class CreateAccountCommand extends Command {
    constructor(model) {
        super(HttpMethod.Post, "account/admin/create");
        this.userCd = model.userCd;
        this.email = model.email;
        this.tel = model.tel;
        this.smsType = model.smsNotificationType?.value ?? null;
    }
    /** 契約者コード */
    userCd = null;
    /** メールアドレス */
    email = "";
    /** 携帯電話番号 */
    tel = "";
    /** SMS通知種別 */
    smsType = null;
}
